// ===== Rascunho da proposta, salvo no navegador enquanto se digita =====
//
// Kaio, 25/09: "precisamos proteger quem faz os orcamentos contra quedas de luz
// ou problemas diversos enquanto digitam uma proposta, seria frustrante ter que
// refazer uma proposta inteira".
//
// POR QUE NO NAVEGADOR, E NAO NO BANCO: gravar a proposta no banco a cada item
// consumiria numero de proposta (sequence) e, pela 0074, mudaria o valor do
// negocio a cada tecla. O rascunho so vira proposta quando o vendedor gera.
//
// "the stored data is saved across browser sessions" / "localStorage data has
// no expiration time" (https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage).
// ARMADILHAS da mesma pagina: em janela anonima, "localStorage data ... is
// cleared when the last 'private' tab is closed"; e o acesso pode lancar
// SecurityError (navegador que bloqueia dados do site). Por isso tudo aqui e
// protegido: sem armazenamento, o builder funciona igual, so sem rascunho.
// E fica neste computador: outro computador nao ve o rascunho.

const VERSAO = 1;
const PREFIXO = 'beamcrm:rascunho-proposta';

export function chaveRascunho(leadId, propostaId) {
  return `${PREFIXO}:v${VERSAO}:${leadId}:${propostaId || 'nova'}`;
}

/** O armazenamento do navegador, ou null quando nao ha (ou foi bloqueado). */
export function armazenamento() {
  try {
    return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function salvarRascunho(storage, chave, estado, agora = new Date()) {
  if (!storage) return false;
  try {
    storage.setItem(chave, JSON.stringify({ v: VERSAO, salvoEm: agora.toISOString(), estado }));
    return true;
  } catch {
    // Cota cheia ou bloqueio: perder o rascunho e melhor que travar a digitacao.
    return false;
  }
}

/** O rascunho guardado, ou null (nenhum, corrompido ou de outra versao). */
export function lerRascunho(storage, chave) {
  if (!storage) return null;
  try {
    const bruto = storage.getItem(chave);
    if (!bruto) return null;
    const r = JSON.parse(bruto);
    if (!r || r.v !== VERSAO || !r.estado || typeof r.estado !== 'object') return null;
    return r;
  } catch {
    return null;
  }
}

export function apagarRascunho(storage, chave) {
  if (!storage) return;
  try { storage.removeItem(chave); } catch { /* sem armazenamento, nada a apagar */ }
}

/** O que vai para o rascunho de um item: sem o resultado da consulta ao Nomus,
 *  que e refeita ao recuperar e so incharia o armazenamento. */
export function itemParaRascunho({ nomus, nomusLoading, ...item }) {
  return item;
}
